export default __webpack_public_path__ + "static/media/145C5227-0439-4A91-ACC6-8A3928150718_1_105_c.75530e8f.jpeg";